import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/En/translations.json";
import translationEL from "./locales/El/translations.json";
import translationRS from "./locales/Ru/translations.json";

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  el: {
    translation: translationEL,
  },
  ru: {
    translation: translationRS,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "el",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
